import LabServiceCollection from "../LabServiceCollection";
import ManagedListModel from "@/models/lab/ManagedListModel";

export default class ManagedListCollection extends LabServiceCollection {
  model() {
    return ManagedListModel;
  }
}
